import _regeneratorRuntime from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _map from "lodash-es/map";
import { createModel } from '@rematch/core';
import { Logger } from '@ecom-alliance/libs';
import { hertzClient } from '@/api/affiliate/serv/oec_affiliate_merchant_crm_api';
import { TagRange } from '@/api/affiliate/data/merchant_crm';
var initialState = {
  creatorTagList: [],
  tagStatus: {
    isError: false,
    isLoading: false,
    error: null
  }
};
export var crmModel = createModel()({
  state: initialState,
  reducers: {
    updateTagList: function updateTagList(state, tags) {
      return _objectSpread(_objectSpread({}, state), {}, {
        creatorTagList: tags
      });
    },
    updateTagStatus: function updateTagStatus(state, tagStatus) {
      return _objectSpread(_objectSpread({}, state), {}, {
        tagStatus: tagStatus
      });
    }
  },
  effects: function effects(dispatch) {
    return {
      initTags: function () {
        var _initTags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _res$data, res, tags;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                dispatch.crmModel.updateTagStatus({
                  isError: false,
                  isLoading: true,
                  error: null
                });
                _context.prev = 1;
                _context.next = 4;
                return hertzClient.TagList({
                  tag_range: TagRange.TagRangeAll,
                  page_no: 1,
                  page_size: 600 // Merchants can create up to 600 tags
                });
              case 4:
                res = _context.sent;
                if (!res.code) {
                  _context.next = 8;
                  break;
                }
                Logger.error("[Error]: get crm tag list.", "Server API: hertzClient.TagList", res.data);
                throw res.data;
              case 8:
                tags = _map((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.tags, function (i) {
                  return {
                    tagLabel: i.name || '',
                    tagValue: i.id || ''
                  };
                });
                dispatch.crmModel.updateTagList(tags);
                dispatch.crmModel.updateTagStatus({
                  isError: false,
                  isLoading: false,
                  error: null
                });
                _context.next = 16;
                break;
              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                dispatch.crmModel.updateTagStatus({
                  isError: true,
                  isLoading: false,
                  error: _context.t0
                });
              case 16:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 13]]);
        }));
        function initTags() {
          return _initTags.apply(this, arguments);
        }
        return initTags;
      }()
    };
  }
});